import { render, staticRenderFns } from "./TheFooterItemList.vue?vue&type=template&id=69650216&scoped=true"
import script from "./TheFooterItemList.vue?vue&type=script&lang=js"
export * from "./TheFooterItemList.vue?vue&type=script&lang=js"
import style0 from "./TheFooterItemList.vue?vue&type=style&index=0&id=69650216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69650216",
  null
  
)

export default component.exports